import * as React from "react";

interface IErrorMessageProps {
    message: string;
}

export const ErrorMessage: React.FC<IErrorMessageProps> = ({ message = null }) => {
    if (!message) { return null; }
    return (
        <p style={ { color: "red" } }>ERROR: { message }</p>
    );
};
